import { Pipe, PipeTransform } from '@angular/core';
import {
  formatKcc20BaseUnitsCompact,
  formatKcc20BaseUnitsValueGrouped,
  supportedKcc20Decimals,
} from '../shared/kcc20-token-amount';

export type Kcc20TokenAmountPipeMode = 'full' | 'compact';

@Pipe({
  name: 'kcc20TokenAmount',
  standalone: true,
})
export class Kcc20TokenAmountPipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    decimals: unknown,
    mode: Kcc20TokenAmountPipeMode = 'full',
    fallback = '--',
    maxDecimals?: number,
  ): string {
    const normalizedDecimals = supportedKcc20Decimals(decimals);
    if (normalizedDecimals === undefined) {
      return fallback;
    }
    return mode === 'compact'
      ? formatKcc20BaseUnitsCompact(value, normalizedDecimals, fallback)
      : formatKcc20BaseUnitsValueGrouped(
          value,
          normalizedDecimals,
          fallback,
          maxDecimals,
        );
  }
}
